<div class="dxc-dropzone dxc-dropzone--drop"
  [class.dxc-dropzone--compact]="compact"
  [class.is-over]="isOver"
  [class.is-disabled]="disabled"
  role="button"
  [attr.tabindex]="disabled ? -1 : 0"
  [attr.aria-disabled]="disabled"
  [attr.aria-label]="ariaLabel || label"
  (click)="open()"
  (keydown)="onKeydown($event)"
  (dragenter)="onDragEnter($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)">

  <span class="dxc-dropzone__icon"><dxc-icon [name]="icon"></dxc-icon></span>

  <span class="dxc-dropzone__copy">
    <span class="dxc-dropzone__label">{{ label }}</span>
    @if (hint && !compact) {
      <span class="dxc-dropzone__hint">{{ hint }}</span>
    }
  </span>

  <!-- Lo que acompaña al rótulo sin ser rótulo: la pastilla «Requerido» de un
       hueco. Proyectado para que la zona no tenga que conocer cada estado. -->
  <span class="dxc-dropzone__aside"><ng-content select="[dxcUploadAside]"></ng-content></span>

  <input #input type="file" class="dxc-sr-only" tabindex="-1" aria-hidden="true"
    [accept]="accept" [multiple]="multiple" [disabled]="disabled" (change)="onPicked($event)">
</div>
